export default "__VITE_ASSET__DddBPomV__"